import React from 'react';
import styled from 'styled-components';
import Home from './pages/Home';
import Loading from './pages/Loading';
import Header from './pages/Header';
import Technologies from './pages/Technologies';
import Projects from './pages/Projects';
import Footer from './pages/Footer';

function App() {
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  const Content = styled.main`
    position: relative;
    height: max-content;
  `;

  return (
    <div className="App">
      {loading ? (
        <Loading props={Loading} />
      ) : (
        <>
          <Header />
          <Content>
            <Home />
            <Technologies />
            <Projects />
          </Content>

          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
